import { useState, useEffect } from "react";
import { X, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";

const AnnouncementBar = () => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const dismissed = localStorage.getItem("announcementDismissed");
    if (dismissed) {
      setIsVisible(false);
    }
  }, []);

  const handleDismiss = () => {
    setIsVisible(false);
    localStorage.setItem("announcementDismissed", "true");
  };

  if (!isVisible) return null;

  return (
    <div className="bg-accent text-accent-foreground relative">
      <div className="container mx-auto px-4 py-2">
        <div className="flex items-center justify-center gap-2 text-sm">
          <Sparkles className="h-4 w-4 animate-pulse" />
          <span className="font-medium">Free Visibility Offer:</span>
          <span>Request a Local SEO + Website Authority Scan and see what to fix first.</span>
          <Link
            to="/funnel/local-seo"
            className="ml-2 underline font-semibold hover:no-underline"
          >
            Get Scan →
          </Link>
        </div>
        <button
          onClick={handleDismiss}
          className="absolute right-2 top-1/2 -translate-y-1/2 p-2.5 min-h-[44px] min-w-[44px] flex items-center justify-center hover:bg-accent-foreground/10 rounded"
          aria-label="Dismiss announcement"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

export default AnnouncementBar;
